// extracted by mini-css-extract-plugin
export default {"ipad_layout":"index_ipad_layout_kS7lT","layout":"index_layout_hw1eU","request_no":"index_request_no_G3RvR"};